import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatInputModule } from '@angular/material/input'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSelectModule } from '@angular/material/select'
import { MatTableModule } from '@angular/material/table'
import { IngredientListElement } from '../../../types/ingredients'
import { MatChipsModule } from '@angular/material/chips'
import { TranslationService } from '../../../services/translation.service'
import { RouterModule } from '@angular/router'

@Component({
  selector: 'app-ingredient-list',
  imports: [
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    FormsModule,
    MatChipsModule,
    RouterModule,
  ],
  templateUrl: './ingredient-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ingredient-list.component.scss',
})
export class IngredientListComponent {
  translationService = inject(TranslationService)

  @Input({ required: true }) ingredients: Array<IngredientListElement> = []
  @Input({ required: true }) displayedColumns: Array<string> = []
}
